<template>
  <textarea
    ref="ta"
    class="console-autotextarea"
    :value="modelValue"
    rows="1"
    @input="onInput"
  />
</template>

<script setup lang="ts">
// A textarea that grows with its content up to a cap, then scrolls. Used where a value can
// be one word or a few sentences (e.g. image alt text) and a fixed single-line input clips.
const props = withDefaults(defineProps<{ modelValue?: string; maxHeight?: number }>(), {
  modelValue: '',
  maxHeight: 160,
})
const emit = defineEmits<{ 'update:modelValue': [string] }>()

const ta = ref<HTMLTextAreaElement | null>(null)

function resize() {
  const el = ta.value
  if (!el) return
  el.style.height = 'auto'
  el.style.height = Math.min(el.scrollHeight, props.maxHeight) + 'px'
}

function onInput(event: Event) {
  emit('update:modelValue', (event.target as HTMLTextAreaElement).value)
  resize()
}

// Resize on mount and whenever the value changes externally (e.g. OCR fills alt text).
onMounted(() => nextTick(resize))
watch(() => props.modelValue, () => nextTick(resize))
</script>

<style scoped>
.console-autotextarea {
  display: block;
  width: 100%;
  resize: none;
  overflow-y: auto;
  line-height: 1.45;
  box-sizing: border-box;
  font-family: inherit;
}
</style>
